import {ReasonCode} from './reason-code';
import {RefundReason} from './refund-reason';
import {Currency} from './currency';
import {TravelCreditType} from './travel-credit-type';

export class IataImport {
  constructor(public Success: number = null,
              public Failures: number = null,
              public Skipped: number = null)
  {}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/iata-import.ts